"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStorybookDiv = exports.StyledFlyoutDiv = exports.StyledChipsTitleDiv = exports.StyledChipsIconWrapperDiv = exports.StyledChipsIconDiv = exports.StyledChipsDiv = exports.StyledCheckboxDiv = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledChipsDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsDiv",
  componentId: "sc-1eivu5u-0"
})(["display:flex;align-items:center;justify-content:space-between;", ";margin-bottom:4px;width:", ";min-width:", ";height:36px;border-radius:40px;background-color:", ";color:", ";overflow:hidden;outline:none;&:hover{background-color:", ";color:", ";.icon{div{svg{fill:", ";}}}}&:focus{background-color:", ";border:1px solid ", ";}&:active{background-color:", ";color:", ";.icon{div{svg{fill:", ";}}}}", ";", " &.multiInput{padding:0px 24px;}"], _shared.theme.typography.link.css, ({
  width,
  showClearButton
}) => width ? width : showClearButton ? '140px' : '124px', ({
  showClearButton
}) => showClearButton ? '140px' : '124px', _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey3, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey5, _shared.theme.palette.ui.cta.yellow, _shared.theme.palette.ui.neutral.grey1, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white, ({
  showOptions
}) => showOptions && `
    background-color: ${_shared.theme.palette.ui.neutral.grey1};
    color: ${_shared.theme.palette.brand.primary.white};
    .icon {
      div {
        svg {
          fill: ${_shared.theme.palette.brand.primary.white};
        }
      }
    }
    `, ({
  disabled
}) => disabled && `
    color: ${_shared.theme.palette.ui.neutral.grey7};
    pointer-events: none;`);

exports.StyledChipsDiv = StyledChipsDiv;

const StyledChipsTitleDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsTitleDiv",
  componentId: "sc-1eivu5u-1"
})(["min-width:72px;overflow:hidden;text-overflow:ellipsis;padding:10px 0px 10px 17px;display:inline;white-space:nowrap;"]);

exports.StyledChipsTitleDiv = StyledChipsTitleDiv;

const StyledChipsIconWrapperDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsIconWrapperDiv",
  componentId: "sc-1eivu5u-2"
})(["display:flex;justify-content:space-between;align-items:center;"]);

exports.StyledChipsIconWrapperDiv = StyledChipsIconWrapperDiv;

const StyledChipsIconDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsIconDiv",
  componentId: "sc-1eivu5u-3"
})(["width:26px;min-width:26px;max-width:26px;.isOpen{svg{transform:rotate(-540deg);}}"]);

exports.StyledChipsIconDiv = StyledChipsIconDiv;

const StyledCheckboxDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledCheckboxDiv",
  componentId: "sc-1eivu5u-4"
})(["& > label{width:100%;}"]);

exports.StyledCheckboxDiv = StyledCheckboxDiv;

const StyledFlyoutDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledFlyoutDiv",
  componentId: "sc-1eivu5u-5"
})(["", ";", ";"], ({
  multiInput
}) => multiInput && `padding: 15px 24px 12px 24px;`, ({
  multiInput
}) => multiInput && `& > div {padding-bottom: 20px}`);

exports.StyledFlyoutDiv = StyledFlyoutDiv;

const StyledStorybookDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledStorybookDiv",
  componentId: "sc-1eivu5u-6"
})(["display:flex;align-items:center;justify-content:center;height:100vh;"]);

exports.StyledStorybookDiv = StyledStorybookDiv;